import React from 'react';
import { InfoCardStack as IInfoCardStack } from '../types/cards.types';
import { useTranslate } from '../lib/i18n';
import InfoCardStack from './InfoCardStack';

interface Props {
  infoCardsContext?: string;
  topic: string;
  infoCardStack: IInfoCardStack;
  isCardExpanded: boolean;
  onToggle: () => void;
  onHideInfoCards: () => void;
  chatContainerRef: React.ForwardedRef<HTMLDivElement>;
}

/**
 * Component for displaying information cards with context-aware messaging and hide functionality
 */
const InfoCardsSection = ({
  infoCardsContext,
  topic,
  infoCardStack,
  isCardExpanded,
  onToggle,
  onHideInfoCards,
}: Props) => {
  const t = useTranslate();

  if (!infoCardStack) return null;

  return (
    <div className="mt-4">
      <p>
        {infoCardsContext === 'TOPIC_INFO'
          ? t('assistantMessage.infoAboutTopic', { topic: t('topics.' + topic.toLowerCase()) })
          : t('infoCardsSection.additionalInfo')}
      </p>
      <div className="mt-4">
        <InfoCardStack
          stack={infoCardStack}
          isExpanded={isCardExpanded}
          onToggle={() => {
            onToggle();
          }}
          iconIndex={0}
        />
        <div className="flex justify-start">
          <button
            onClick={onHideInfoCards}
            className="mt-4 flex h-[24px] items-center justify-center space-x-2 rounded-[10px] bg-muted px-3 text-xs text-muted-foreground"
          >
            <span>{t('assistantMessage.infoCards.hide')}</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default InfoCardsSection;
